// extracted by mini-css-extract-plugin
module.exports = {"save-section":"_1ki_26-NX6rGjvEAlxe29H","text":"_3jvOm8fc5Kgu3VlV7UBWYl","buttons-container":"-TIjzDhR3D751VZzJWwlR","inline":"_3BbWPlhiUeoeE3SyFVrLF6"};